
function clearValidationStyles($parentElement) {
    $parentElement.find(".form-group").removeClass("has-error").removeClass("has-success");
    $parentElement.find(".validateMessage").toggle(false);
    $parentElement.find(".control-label").find(".glyphicon").remove();
    $(".validationMessage").toggle(false);
}

function setInputToFailed(input) {
    var $label = [];
    window["testInput"] = input;
    console.log(input);
    if ($(input).is("input[type='radio']")) {
        console.log("setting radio to failed");
        $(input).parent().parent().parent().parent().parent().removeClass("has-success");
        $(input).parent().parent().parent().parent().parent().addClass("has-error");
        $(input).parent().parent().parent().parent().parent().find(".radio").each(function () {
            $(this).removeClass("has-success");
            $(this).addClass("has-error");
        });
        $label = $(input).parent().parent().parent().parent().parent().children("label:first");
    } else if ($(input).is("input[type='text']") || $(input).is("input[type='number']")) {
        //console.log("setting text to failed");
        $(input).parent().removeClass("has-success");
        $(input).parent().addClass("has-error");
        $label = $(input).parent().find("label");
    } else if (($(input).is("span") || $(input).is("div")) && ($(input).hasClass("k-widget") || $(input).hasClass("k-dropdown"))) {
        //console.log("setting widget to failed");
        $(input).parent().removeClass("has-success");
        $(input).parent().addClass("has-error");
        $label = $(input).parent().children("label:first");
    } else if ($(input).is("textarea")) {
        //console.log("setting textarea to failed");
        $(input).parent().removeClass("has-success");
        $(input).parent().addClass("has-error");
        $label = $(input).parent().children("label:first");

    } else if ($(input).is("input[type='checkbox']")) {
        //console.log("setting checkbox to failed");
        $(input).parent().parent().parent().parent().parent().removeClass("has-success");
        $(input).parent().parent().parent().parent().parent().addClass("has-error");
        $(input).parent().parent().parent().parent().parent().find("[type='checkbox']").each(function () {
            $(this).removeClass("has-success");
            $(this).addClass("has-error");
        });
        $label = $(input).parent().parent().parent().parent().parent().children("label:first");
    }

    if ($label.length > 0) {
        var $glyphicon = $label.find(".glyphicon");
        if ($glyphicon.length > 0) {
            $glyphicon.removeClass("glyphicon-ok");
            if (!$glyphicon.hasClass("glyphicon-remove")) {
                $glyphicon.addClass("glyphicon-remove");
            }
        } else {
            $label.append(
                '<span class="glyphicon glyphicon-remove" style="margin-left:10px;" aria-hidden="true"></span>');
        }
    }
}

function setInputToPass(input) {
    var $label = [];
    //console.log("setting input to passed");
    if ($(input).is("input[type='text']") || $(input).is("input[type='number']") || $(input).is("select")) {
        $(input).parent().removeClass('has-error');
        $(input).parent().addClass('has-success');
        $label = $(input).parent().find("label");
    } else if ($(input).is("input[type='radio']")) {
        $(input).parent().parent().parent().parent().parent().removeClass('has-error');
        $(input).parent().parent().parent().parent().parent().addClass('has-success');
        $(input).parent().parent().parent().parent().parent().find(".radio").each(function () {
            $(this).removeClass("has-error");
            var checkedRadio = $(this).find("input:radio:checked");
            if (checkedRadio && checkedRadio.length > 0) {
                $(this).addClass("has-success");
            } else {
                $(this).removeClass("has-success");
            }
        });
        $label = $(input).parent().parent().parent().parent().parent().find("label").first();
    } else if (($(input).is("span") || $(input).is("div")) && ($(input).hasClass("k-widget") || $(input).hasClass("k-dropdown"))) {
        $(input).parent().removeClass("has-error");
        $(input).parent().addClass("has-success");
        $label = $(input).parent().children("label:first");
    } else if ($(input).is("textarea")) {
        //console.log("setting textarea to success");
        $(input).parent().removeClass("has-error");
        $(input).parent().addClass("has-success");
        $label = $(input).parent().children("label:first");

    } else if ($(input).is("input[type='checkbox']")) {
        //console.log("setting checkbox to passed");
        $(input).parent().parent().parent().parent().parent().removeClass('has-error');
        $(input).parent().parent().parent().parent().parent().addClass('has-success');
        $(input).parent().parent().parent().parent().parent().find("input[type='checkbox']").each(function () {
            $(this).removeClass("has-error");
            var checkedRadio = $(this).find("input:checkbox:checked");
            if (checkedRadio && checkedRadio.length > 0) {
                $(this).addClass("has-success");
            } else {
                $(this).removeClass("has-success");
            }
        });
        $label = $(input).parent().parent().parent().parent().parent().find("label").first();
    }

    if ($label.length > 0) {
        var $glyphicon = $label.find(".glyphicon");
        if ($glyphicon.length > 0) {
            $glyphicon.removeClass("glyphicon-remove");
            if (!$glyphicon.hasClass("glyphicon-ok")) {
                $glyphicon.addClass("glyphicon-ok");
            }
        } else {
            $label.append(
                '<span class="glyphicon glyphicon-ok" style="margin-left:10px;" aria-hidden="true"></span>');
        }
    }
}




function validateCurrentTab(targetedWizard) {
    if (targetedWizard != null) {
        // assume it's true in case any of this custom setup isn't implemented
        // to hook this up properly the following criteria must be fulfilled in a standard page:
        // 1) page uses knockout, and the entire page is a model named pageModel in global scope
        // 2) the knockout pageModel uses knockout validation
        // 3) the name of the tab in the wizard is the same name as the property on the pageModel
        var currentTabIsValid = true;
        var currentTabHref = $("#" + targetedWizard + " > .active").find("a").first().attr("href").replace("#", "");
        // there is a variable called pageModel and it contains a property the same name as the current tab id of the wizard
        if (window["pageModel"]) {
            if (currentTabHref in window["pageModel"]()) {
                var tabModel = ko.validatedObservable(window["pageModel"]()[currentTabHref]());
                var tabResult = ko.validation.group(window["pageModel"]()[currentTabHref], { deep: true });
                var tabDataIsValid = window["pageModel"]()[currentTabHref].isValid();
                if (!tabDataIsValid) {
                    tabResult.showAllMessages(true);
                    currentTabIsValid = false;
                }
            } else {
                console.log("No property " + currentTabHref + " found on variable pageModel. Make sure the tab id corresponding to the model property is the same name as the property on pageModel.");
            }

        } else {
            console.log("Cannot find variable pageModel in global scope.");

        }

        return currentTabIsValid;
    }
    return true
}


(function ($) {

    
    "use strict"; // Start of use strict
    $(document).on('click', function (e) {
        $('[data-toggle="tooltip"]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.tooltip').has(e.target).length === 0) {
                (($(this).tooltip('hide').data('bs.tooltip') || {}).inState || {}).click = false; // fix for BS 3.3.6
            }

        });
        $('[data-toggle="popover"]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false; // fix for BS 3.3.6
            }

        });
    });

    $('[data-toggle="tooltip"]').tooltip({
        delay: { show: 200, hide: 200 },
        html: true,
        trigger: "click"
    });

    $('[data-toggle="popover"]').popover({
        delay: { show: 200, hide: 200 },
        html: true,
        trigger: "click",
        container: "body"
    });
    $.fn.slideToggleBool = function (show) {
        if (show) {
            $(this).slideDown();
        }
        else {
            $(this).slideUp();
        }
    }
    var pathArray = location.href.split('/');
    var protocol = pathArray[0];
    var host = pathArray[2];
    var homePageUrl = protocol + '//' + host + "/";
    var baseCurrentUrl = window.location.href.split('?')[0].split("#")[0];

    var isHomePage = homePageUrl === window.location.href.split('?')[0].split("#")[0] || window.location.href.split('?')[0].split("#")[0] === homePageUrl + "Demos/Home";
    var menuTransformOffSet = isHomePage ? 450 : -1;

    //required to prevent browser scrolling to the tab in the HTML when clicking a tab link in conjunction with our tab custom code
    $(document).on("click", "a[href^='#'][data-toggle='tab']", function (event) {
        event.preventDefault();
        console.log("tab toggled click");
        history.pushState({}, "", this.href);
    });

    // jQuery for page scrolling feature - requires jQuery Easing plugin
    $('a.page-scroll').bind('click', function (event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: ($($anchor.attr('href')).offset().top - 240)
        }, 600, 'linear');
        event.preventDefault();
    });

    $("#sidebar").affix({
        offset: {
            top: 180
        }
    }).on('affix.bs.affix', function () {

        $("#sidebar").each(function () { setAffixContainerSize(this) });
        });
       
    function setAffixContainerSize(element) {
        var $element = $(element);
        var $parent = $element.parent();
        var parentPadding = parseInt($parent.css("padding-left")) + parseInt($parent.css("padding-right"));
        var elementPadding = parseInt($element.css("padding-left")) + parseInt($element.css("padding-right"));
        $element.width($element.parent().innerWidth() - (parentPadding + elementPadding));
    }

    $(window).resize(function () {
        $("#sidebar").each(function () { setAffixContainerSize(this) });
    });

    var $body = $(document.body);
    var navHeight = $('.navbar').outerHeight(true);

    $body.scrollspy({
        target: '#leftCol',
        offset: navHeight + 170
    });

    if ($('#to-top').length) {
        var scrollTrigger = 100,
            backToTop = function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > scrollTrigger && $('#to-top').css("display") === "none") {
                    $('#to-top').fadeIn();
                } else if (scrollTop < scrollTrigger && $('#to-top').css("display") === "inline") {
                    $('#to-top').fadeOut();
                }
            };
        backToTop();
        $(window).on('scroll', function () {
            backToTop();
        });
    }
    if ($('#to-bottom').length) {
        
        var toBottom = function () {
            var scrollTriggerRemoval = $(document).height() - 100;
                var scrollTop = $(window).scrollTop() + $(window).height();
                if (scrollTop > scrollTriggerRemoval && $('#to-bottom').css("display") === "inline") {
                    $('#to-bottom').fadeOut();
                } else if (scrollTop <= scrollTriggerRemoval && $('#to-bottom').css("display") === "none") {
                    $('#to-bottom').fadeIn();
                }
            };
        toBottom();
        $(window).on('scroll', function () {
            toBottom();
        });
    }



    // // Highlight the top nav as scrolling occurs
    // $('body').scrollspy({
    //     target: '.navbar-fixed-top',
    //     offset: 51
    // });

    // Closes the Responsive Menu on Menu Item Click
    $('.navbar-collapse ul li a:not(.dropdown-toggle)').click(function () {
        $('.navbar-toggle:visible').click();
    });

    // allows previous and next buttons to allow for navigating through bootstrap tabs (wizard), targeting is supplied through data-target-wizard-id attribute
    //$("#thirdNav").on("click", ".wizard-previous-button", function (e) {
    //    e.preventDefault();
    //    var $this = $(this);
    //    var targetedWizard = $this.attr("data-target-wizard-id");
    //    if (validateCurrentTab(targetedWizard) === true) {
    //        moveToPreviousTab(targetedWizard);
    //        deactivatePreviousButton(targetedWizard);
    //        activateNextButton(targetedWizard);
    //    }
        

    //});

    //$("#thirdNav").on("click", ".wizard-next-button", function (e) {
    //    e.preventDefault();
    //    var $this = $(this);
    //    var targetedWizard = $this.attr("data-target-wizard-id");
    //    if (validateCurrentTab(targetedWizard) === true) {
    //        moveToNextTab(targetedWizard);
    //        deactivateNextButton(targetedWizard);
    //        activatePreviousButton(targetedWizard);
    //    }
        
    //});
    $('a[data-toggle="tab"]').on('show.bs.tab', function(e) {
        var wizardId = $(e.relatedTarget).parent().parent().prop("id");
        if (validateCurrentTab(wizardId) !== true) {
            e.preventDefault();
            e.stopPropagation();
        }
    });
    //$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {

    //    window.location.hash = $(e.target).attr("href");
    //    var isFirstLi = $(e.target).parent("li").prev("li").length === 0;
    //    var isLastLi = $(e.target).parent("li").next("li").length === 0;
    //    var wizardId = $(e.target).parent("li").parent("ul").attr("id");
    //    if (isFirstLi) {
    //        deactivatePreviousButton(wizardId);
    //        activateNextButton(wizardId);
    //    } else if (isLastLi) {
    //        activatePreviousButton(wizardId);
    //        deactivateNextButton(wizardId);
    //    } else {
    //        activateNextButton(wizardId);
    //        activatePreviousButton(wizardId);
    //    }
    //});

    
    // OFFSET FOR MAIN NAVIGATION
    $('#mainNav')
        .affix({
            offset: {
                top: menuTransformOffSet
            }
        });

    $('#subNav')
        .affix({
            offset: {
                top: menuTransformOffSet
            }
        });


    $("")

    // Initialize and Configure Scroll Reveal Animation
    window.sr = ScrollReveal();
    sr.reveal('.sr-icons', {
        duration: 600,
        scale: 0.3,
        distance: '0px'
    }, 200);
    sr.reveal('.sr-button', {
        duration: 1000,
        delay: 200
    });
    sr.reveal('.sr-contact', {
        duration: 600,
        scale: 0.3,
        distance: '0px'
    }, 300);

    sr.reveal('.reveal', {
        duration: 600,
        scale: 0.3,
        distance: '0px'
    }, 200);

    sr.reveal('.reveal-2', {
        duration: 600,
        scale: 0.3,
        distance: '0px'
    }, 200);

    // Initialize and Configure Magnific Popup Lightbox Plugin
    $('.popup-gallery').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
        }
    });

})(jQuery); // End of use strict


function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function renderTemplate(templateSelector, templateOutputDivSelector, data) {
    var source = $(templateSelector).html();
    var template = Handlebars.compile(source);
    var html = template(data);
    $(templateOutputDivSelector).html(html);
}

function objectHasProperty(obj, prop) {
    var proto = obj.__proto__ || obj.constructor.prototype;
    return (prop in obj) &&
        (!(prop in proto) || proto[prop] !== obj[prop]);
}

$.fn.extend({
    animateCss: function (animationName, callback) {
        var animationEnd = (function (el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        })(document.createElement('div'));

        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);

            if (typeof callback === 'function') callback();
        });

        return this;
    }
});